export const LOGIN = "/login";
export const DASHBOARD = "/dashboard";
export const CONSULTA = "/consulta";
export const CERTIFICATES = "/:hash";
